module.exports = __webpack_public_path__ + "static/media/eye.569d3d6a.png";